import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";

//fonts
import "./font/bookman-old-style.ttf";
import "./font/BOOKOS.TTF";
import "./font/BOOKOSB.TTF";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
